import React, { useState, memo, useEffect } from "react";

import OutsideAlerter from "../../../outsideAlerter";
import { isDesktop, isMobile } from "utils/deviceType";

import styles from "../../ABheader.scss";
import { faHeaderNavClick } from "components/ABheader/services/ABheader.analytics";
const {
  main_navigation,
  navbar_area,
  top_head_sectioin,
  top_nav_item,
  navlist,
  nav_footer,
  btn,
  open_mega_nav,
  subnav,
  mega_menu,
  menu_text,
  nav_text,
  animated_arrow,
  mega_navigation,
  megamenu,
  inset_menu_wrapper,
  navigation_list,
  focus,
  sub_submenu,
  new_badge,
  sidebar_nav_wrapper,
  back_title,
  sidebar_nav_wrapper_scroller,
  sub_nav_items,
  menu_details,
  active,
  bg_overlay,
  container,
  grandchild_menu,
  category_group,
  category_header,
  category_title,
  grandchild_items,
  back_second_level,
  grand_child_item,
} = styles;
const headerScreenBreakPoint = 1279;
var headerWindowSize = window.innerWidth <= headerScreenBreakPoint;

export default function MainNavigationComponent({
  top_header,
  nav_header,
  activeHeadingIndex,
  handleHeadingClick,
  setShowTalkToAnExpert,
  flowName,
  setActiveHeadingIndex,
  onTalkToExpertClickCallback,
}) {
  const handleOutsideClick = () => {
    if (isDesktop()) {
      setActiveHeadingIndex(null);
    }
  };

  const handleTalkToExpertClick = () => {
    setShowTalkToAnExpert(true);
    onTalkToExpertClickCallback && onTalkToExpertClickCallback();
  };

  return (
    <div className={main_navigation}>
      <div className={navbar_area}>
        <div className={top_head_sectioin}>
          <div className={container}>
            <ul className={top_nav_item}>
              <TopHeaderLinks top_header={top_header} flowName={flowName} />
            </ul>
          </div>
        </div>
        <OutsideAlerter onOutsideClick={() => handleOutsideClick()}>
          <ul className={navlist}>
            <HeaderCategory
              nav_header={nav_header}
              activeHeadingIndex={activeHeadingIndex}
              handleHeadingClick={handleHeadingClick}
              flowName={flowName}
              setActiveHeadingIndex={setActiveHeadingIndex}
            />
          </ul>
        </OutsideAlerter>
        {!isDesktop() && (
          <div className={nav_footer}>
            <button className={btn} onClick={handleTalkToExpertClick}>
              Talk To An Expert
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const TopHeaderLinks = memo(({ top_header, flowName }) => {
  const setTopData = top_header.map((topLinkData, index) => (
    <li key={index} className={topLinkData.isCurrent === true ? active : ""}>
      <a href={topLinkData.linkUrl} onClick={() => faHeaderNavClick({ flowName: flowName, segment: topLinkData.linkText })}>
        {topLinkData.linkText}
      </a>
    </li>
  ));
  return setTopData;
});

const HeaderCategory = memo(({ nav_header, activeHeadingIndex, handleHeadingClick, flowName, setActiveHeadingIndex }) => {
  let navitationList = nav_header?.map((headingItem, index) => (
    <li
      key={index}
      className={`
       ${activeHeadingIndex == index ? open_mega_nav : ""}
        ${headingItem.hasSubMenu === true ? subnav : ""} ${headingItem.megaMenu === true ? mega_menu : ""} `}
    >
      {headingItem.hasSubMenu === true ? (
        <div
          className={menu_text}
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleHeadingClick(index);
              faHeaderNavClick({ flowName: flowName, segment: headingItem.title });
            }
          }}
          onClick={() => {
            handleHeadingClick(index);
            faHeaderNavClick({ flowName: flowName, segment: headingItem.title });
          }}
        >
          <span className={nav_text}>{headingItem.title}</span>
          {headingItem.hasSubMenu === true ? <span className={animated_arrow}></span> : ""}
        </div>
      ) : (
        <a
          className={menu_text}
          href={headingItem.link}
          onClick={() => {
            handleHeadingClick(index);
            faHeaderNavClick({ flowName: flowName, segment: headingItem.title });
          }}
        >
          <span className={nav_text}>{headingItem.title}</span>
        </a>
      )}
      {headingItem.hasSubMenu === true ? (
        <div className={mega_navigation}>
          <div className={megamenu}>
            <div className={inset_menu_wrapper}>
              <ul className={navigation_list}>
                <HeaderCategoryLinks dataValue={headingItem} activeHeadingIndex={activeHeadingIndex} flowName={flowName} />
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </li>
  ));

  return navitationList;
});

const HeaderCategoryLinks = memo(({ dataValue, activeHeadingIndex, flowName, segment }) => {
  const [activeSubNavIndex, setActiveSubNavIndex] = useState(null);
  useEffect(() => {
    setActiveSubNavIndex(null);
  }, [activeHeadingIndex]);
  const subMenuData = dataValue?.item?.map(function (hdata, index) {
    return (
      <li
        key={index}
        className={`${(activeSubNavIndex == null && hdata.isActive === true) || activeSubNavIndex == index ? `${focus} ` : ""} ${
          activeSubNavIndex == index ? active : ""
        }`}
      >
        {hdata.linkUrl ? (
          <a
            className={sub_submenu}
            href={hdata.linkUrl}
            onClick={() => {
              setActiveSubNavIndex(index);
              faHeaderNavClick({ flowName: flowName, segment: dataValue.title, product: hdata.heading });
            }}
          >
            <span className={nav_text}>{hdata.heading}</span>
            {hdata.subMenuItems ? <span className={animated_arrow}></span> : ""}
          </a>
        ) : (
          <div
            className={menu_text}
            parentdata={dataValue.title}
            onClick={() => {
              setActiveSubNavIndex(index);
              faHeaderNavClick({ flowName: flowName, segment: dataValue.title, product: hdata.heading });
            }}
          >
            <span className={nav_text}>
              {hdata.heading} {hdata.badgeText ? <span className={new_badge}>{hdata.badgeText}</span> : ""}
            </span>

            {headerWindowSize ? <>{hdata.subMenuItems ? <span className={animated_arrow}></span> : ""}</> : ""}
          </div>
        )}
        {hdata.subMenuItems ? (
          <SubMenuItems
            subdata={hdata.subMenuItems}
            setActiveSubNavIndex={setActiveSubNavIndex}
            subNavTitle={hdata.heading}
            segment={dataValue.title}
            flowName={flowName}
          />
        ) : (
          " "
        )}
      </li>
    );
  });
  return subMenuData;
});

const SubMenuItems = memo(({ subdata, setActiveSubNavIndex, subNavTitle, segment, flowName }) => {
  const itemCategory = subdata?.listItems?.hasGrandChild;
  return (
    <div className={sidebar_nav_wrapper}>
      {headerWindowSize ? (
        <div className={back_title} onClick={() => setActiveSubNavIndex(null)}>
          <i className={"aeh-icon-chevron-left"}></i> <span>{segment}</span>
        </div>
      ) : (
        ""
      )}
      <div className={sidebar_nav_wrapper_scroller}>
        <ul className={`${sub_nav_items} ${itemCategory ? grand_child_item : ""}`}>
          {itemCategory ? (
            <HasGrandChild
              megaData={subdata?.listItems}
              setActiveSubNavIndex={setActiveSubNavIndex}
              subNavTitle={subNavTitle}
              segment={segment}
              flowName={flowName}
            />
          ) : (
            <MegaMenu megaData={subdata?.listItems} flowName={flowName} segment={segment} subNavTitle={subNavTitle} />
          )}
        </ul>
      </div>
    </div>
  );
});

const HasGrandChild = memo(({ megaData,  subNavTitle, flowName }) => {
  const [activeCategoryIdx, setActiveCategoryIdx] = useState(null);

  if (!megaData?.hasGrandChild) return null;

  return (
    <div className={grandchild_menu}>
      {megaData?.subMenuText?.map((category, catIdx) => {
        let shouldShowBadge = false;
        if (category.expiryDate) {
          const today = new Date().setHours(0, 0, 0, 0);
          const expiryDate = new Date(category.expiryDate).setHours(0, 0, 0, 0);
          shouldShowBadge = today <= expiryDate;
        }

        return (
          <div className={`${category_group} ${activeCategoryIdx === catIdx ? active : ""}`} key={catIdx}>
            <div
              className={category_header}
              data-parentdata={category.categoryText}
              onClick={(e) => {
                setActiveCategoryIdx(activeCategoryIdx === catIdx ? null : catIdx);
                e.stopPropagation();
              }}
            >
              <h4 className={category_title}>
                {category.categoryText} {shouldShowBadge && <span className={new_badge}>New</span>}
              </h4>
              {headerWindowSize ? <span className={animated_arrow}></span> : null}
            </div>
            <div className={sidebar_nav_wrapper_scroller}>
              {headerWindowSize ? (
                <div
                  className={`${back_title} ${back_second_level}`}
                  onClick={(e) => {
                    setActiveCategoryIdx(null);
                    e.stopPropagation();
                  }}
                >
                  <i className="aeh-icon-chevron-left"></i> <span>{category.categoryText}</span>
                </div>
              ) : null}
              <ul className={grandchild_items}>
                {category.grandSubMunu?.map((item, idx) => (
                  <li key={idx}>
                    <div className={menu_details}>
                      <a
                        href={item.linkUrl}
                        onClick={() =>
                          faHeaderNavClick({
                            flowName,
                            segment: category.categoryText,
                            lob: subNavTitle,
                            product: item.linkText,
                          })
                        }
                      >
                        {item.linkText}
                      </a>
                      {window.innerWidth > headerScreenBreakPoint && item.linkInfo ? <p>{item.linkInfo}</p> : null}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
});

const MegaMenu = memo(({ megaData, flowName, segment, subNavTitle }) => {
  return megaData?.subMenuText?.map((mdata, index) => (
    <>
      {mdata.linkText ? (
        <li key={index}>
          <div className={menu_details}>
            <a
              href={mdata.linkUrl}
              onClick={(e) =>
                faHeaderNavClick({ flowName: flowName, segment: segment, lob: subNavTitle, product: mdata.linkText })
              }
            >
              {mdata.linkText}
            </a>
            {window.innerWidth > headerScreenBreakPoint ? <>{mdata.linkInfo ? <p>{mdata.linkInfo}</p> : ""}</> : ""}
          </div>
        </li>
      ) : (
        ""
      )}
    </>
  ));
});
